import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const TextInput = styled(TextField)(() => ({
  backgroundColor: "#F8F8F8",
  fontFamily: "Gotham, sans-serif",
  "& .MuiFilledInput-root": {
    fontFamily: "Gotham, Arial, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "0.64px",
    lineHeight: "20px",

    "&::before": {
      borderBottom: "1px solid transparent !important", // !important is needed to overwrite focus and hover styles
    },
    "&::after": {
      borderBottom: "1px solid transparent !important", // !important is needed to overwrite focus and hover styles
    },
  },
  "& .MuiInputBase-colorError": {
    boxSizing: "border-box",
    border: "2px solid #ef4444",
    borderRadius: "0",
  },
  "& label.MuiInputLabel-filled": {
    color: "#1d1d1d",
    opacity: "0.5",
    fontFamily: "Gotham, Arial, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    transform: "translate(9px, 12px) scale(1)",
  },
  "& label.MuiInputLabel-filled.MuiInputLabel-shrink": {
    color: "rgb(86, 86, 86)",
    lineHeight: "16px",
    transform: "translate(9px, 3px) scale(1)",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",

    "&:hover": {
      backgroundColor: "transparent",
    },

    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  "& input.MuiInputBase-input": {
    font: "inherit",
    padding: "16px 10px 6px 10px",
  },
  "& .MuiFormHelperText-root": {
    fontFamily: "Gotham, Arial, sans-serif",
    fontSize: 13,
  },
}));

export default TextInput;
